import { SET_TRANSFER_RECORD_BATCH } from '../actions/transfers';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_TRANSFER_RECORD_BATCH:
    return { ...state, batch: action.batch };
  default:
    return state;
  }
}
